import { FormattedMessage } from "react-intl";
import type { ExtendedPersonFilters } from "@/lib/search-filters";
import {
  PERSON_FIELDS,
  PERSON_FREQUENT_FIELD_KEYS,
  isFieldActive,
  type OptionsByKey,
} from "@/lib/filter-fields";
import { FilterBuilder } from "./FilterBuilder";

// The Teamplayer category. The pill UI is FilterBuilder, shared with every other category that has
// facets; the field list is in @/lib/filter-fields. This file is only what binds the two together
// for a PERSON search.

export function PersonFilterBuilder({
  person,
  setPerson,
  optionsByKey,
  onEnter,
  compact = false,
}: {
  person: ExtendedPersonFilters;
  setPerson: React.Dispatch<React.SetStateAction<ExtendedPersonFilters>>;
  optionsByKey: OptionsByKey;
  onEnter?: () => void;
  compact?: boolean;
}) {
  const activeCount = PERSON_FIELDS.filter((f) => isFieldActive(f, person)).length;
  return (
    <FilterBuilder
      fields={PERSON_FIELDS}
      frequentKeys={PERSON_FREQUENT_FIELD_KEYS}
      heading={
        <FormattedMessage
          id="personFilter.heading"
          defaultMessage="Team Player filters{count, plural, =0 {} other { · # active}}"
          values={{ count: activeCount }}
        />
      }
      value={person}
      setValue={setPerson}
      optionsByKey={optionsByKey}
      onEnter={onEnter}
      compact={compact}
    />
  );
}
